import { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface TosAcceptanceDialogProps {
  open: boolean;
  onAccepted: () => void;
}

/**
 * Dialog to accept updated Terms of Service.
 * This replaces the old Angular accept-new-tos.html modal.
 */
export function TosAcceptanceDialog({
  open,
  onAccepted,
}: TosAcceptanceDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleAccept = async () => {
    setIsLoading(true);
    try {
      await axios.post("/profile/acceptNewTos");
      onAccepted();
    } catch (error) {
      console.error("Error accepting TOS:", error);
      // Reload page as fallback (same as old Angular behavior)
      window.location.reload();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-md"
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Updated Terms of Service</DialogTitle>
          <DialogDescription>
            We have updated our Terms of Service. Please review and accept to
            continue using Sked Social.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-gray-600">
            By clicking &quot;Accept&quot;, you agree to our updated{" "}
            <a
              href="https://skedsocial.com/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://skedsocial.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>

        <DialogFooter>
          <Button
            onClick={handleAccept}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? "Accepting..." : "Accept Terms of Service"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
